module.exports = __webpack_public_path__ + "img/nosport.9d9e91a8.jpg";